import { Text, Tooltip, VFlow } from 'bold-ui'
import { CpfOrCns } from 'components/CpfOrCns'
import { css } from 'emotion'
import React, { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'
import { humanizeAge } from 'util/date/humanize-age'
import { ParticipanteModel } from 'view/atividade-coletiva/model-atividadeColetiva'
import { getNomeCidadao, hasDataNascimentoAfterDataAtividade } from 'view/atividade-coletiva/utils-atividadeColetiva'

interface ParticipanteCidadaoInfoProps {
  participante: ParticipanteModel
  dataAtividade: LocalDate
}

export const ParticipanteCidadaoInfo = (props: ParticipanteCidadaoInfoProps) => {
  const { dataAtividade, participante } = props
  const cidadao = participante.cidadao ?? participante.cidadaoParticipante
  const cidadaoDataObito = participante.cidadao?.dataObito

  const cidadaoHasDataNascimentoAfterDataAtividade = hasDataNascimentoAfterDataAtividade(
    dataAtividade,
    cidadao.dataNascimento
  )

  const cidadaoIdadeTooltipText = cidadaoHasDataNascimentoAfterDataAtividade
    ? 'A data de nascimento do cidadão foi atualizada e é posterior à data desta atividade'
    : 'Idade no dia desta atividade'

  return (
    <VFlow vSpacing={0.1} style={styles.container}>
      <Text fontWeight='bold'>{getNomeCidadao(cidadao)?.titleCase()}</Text>
      <CpfOrCns cpf={cidadao.cpf} cns={cidadao.cns} defaultText='' />
      <Text>
        {cidadao.dataNascimento && (
          <Fragment>
            <Tooltip text={dataAtividade ? cidadaoIdadeTooltipText : ''} placement='bottom-start'>
              {cidadaoHasDataNascimentoAfterDataAtividade ? (
                <Text color='danger'>{formatDate(cidadao.dataNascimento)}</Text>
              ) : (
                <Text>{humanizeAge(cidadao.dataNascimento, dataAtividade)}</Text>
              )}
            </Tooltip>
            {` | `}
          </Fragment>
        )}
        {`${cidadao.sexo?.capitalize() ?? '-'}`}
      </Text>
      {cidadaoDataObito && (
        <Fragment>
          <Text fontWeight='bold' color='danger'>
            Óbito em:{' '}
          </Text>
          <Text>{formatDate(cidadaoDataObito)}</Text>
        </Fragment>
      )}
    </VFlow>
  )
}

const styles = {
  container: css`
    margin: 1rem 0;
  `,
}
